import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const SadaDetail = lazy(() =>
  import('@/modules/uskladneni/SadaDetail').then((m) => ({ default: m.SadaDetail })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/servis/uskladneni/$id',
  component: () => (
    <Suspense fallback={null}>
      <SadaDetail />
    </Suspense>
  ),
});
